import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import axios from "axios";
import Header from "../components/login/Header";
import LoginForm from "../components/login/LoginForm";
import BackgroundImage from "../components/login/BackgroundImage";
import { navigate } from "gatsby";
import CircularProgress from "@material-ui/core/CircularProgress";
import Layout from "../components/layout";
import { Grid, Container } from "@material-ui/core";

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

const Login = (props) => {
  const [loading, setLoading] = useState(true);
  const [loggingIn, setLoggingIn] = useState(false);
  const [error, setError] = useState();
  const [cookies, setCookie, removeCookie] = useCookies(["tsaAuth"]);

  useEffect(() => {
    if (localStorage.getItem("user") && localStorage.getItem("loggedIn")) {
      //navigate("/dashboard");
    } else if (cookies.tsaAuth) {
      axios
        .get(
          `https://umbrella.takeshape.com.au/wp-json/wp/v2/users/${cookies.tsaAuth.id}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.tsaAuth.token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          localStorage.setItem("loggedIn", true);
          localStorage.setItem("user", JSON.stringify(res.data));
          console.log(res.data);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [props.auth]);

  const handleSubmit = (data) => {
    setLoggingIn(true);
    axios
      .post(`https://umbrella.takeshape.com.au/wp-json/jwt-auth/v1/token`, {
        username: data.email,
        password: data.password,
      })
      .then((res) => {
        console.log(res);
        if (undefined === res.data.token) {
          setError(res.data.message);
          setLoggingIn(false);
        } else {
          if (
            res.data.roles.includes("lvl1-adventure") ||
            res.data.roles.includes("lvl2-adventures") ||
            res.data.roles.includes("lvl1-fitness") ||
            res.data.roles.includes("lvl2-fitness") ||
            res.data.roles.includes("lvl1-vitality") ||
            res.data.roles.includes("lvl2-fitness") ||
            res.data.roles.includes("lvl3-member") ||
            res.data.roles.includes("administrator")
          ) {
            localStorage.setItem("loggedIn", true);
            localStorage.setItem("user", JSON.stringify(res.data));
            const today = new Date();
            setCookie(
              "tsaAuth",
              { id: res.data.id, token: res.data.token },
              { expires: today.addDays(7) }
            );
            navigate("/");
          } else {
            setError(
              `Looks like you are not a member. Head over to www.takeshape.com.au to learn more about our memberships`
            );
            setLoggingIn(false);
          }
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        setError(err.response.data.message);
        setLoggingIn(false);
      });
  };

  return (
    <Layout>
      {!loading && (
        <Grid container style={{ maxHeight: "85vh", overflow: "hidden" }}>
          <Grid item xs={12} md={4}>
            <Container style={{ marginTop: 30, height: "100%" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Header />
                </Grid>
                <Grid item xs={12}>
                  <div className="mt-6 relative">
                    <LoginForm handleSubmit={handleSubmit} />
                    {error && (
                      <div className="rounded-md bg-red-50 p-4">
                        <div className="flex">
                          <div className="flex-shrink-0">
                            <svg
                              className="h-5 w-5 text-red-400"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                          <div className="ml-3">
                            <h3 className="text-sm leading-5 font-medium text-red-800">
                              {error}
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Container>
            {loggingIn && <CircularProgress color="secondary" />}
          </Grid>
          <Grid item xs={12} md={8}>
            <BackgroundImage />
          </Grid>
        </Grid>
      )}
    </Layout>
  );
};

export default Login;
